(function () {
    'use strict';

    angular.module("imApp").factory("sopClsService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1848,
                    parameters: parms || {}
                });
            },
            listChoices: function (parms) {
                return $ihttp.post({
                    method: 1851,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
